'use client'

import { withCallbacksServerAction } from '@/core/actions/with-callbacks.server.action'
import { ROUTES } from '@/core/constants/routes'
import { STORAGE_KEYS } from '@/core/constants/storage-keys'
import { storageService } from '@/core/services/storage'
import { useAuth } from '@/core/store/auth'
import { logoutServerAction } from '@/features/auth/actions/logout.server.action'
import { useRouter } from '@/i18n/navigation'
import { addToast } from '@heroui/react'
import { useTranslations } from 'next-intl'
import { useActionState } from 'react'

type Props = {
  label?: React.ReactNode
  onSuccess?: () => void
}

export const LogoutForm: React.FC<Props> = ({ label, onSuccess }) => {
  const t = useTranslations()
  const { user, clearUser } = useAuth()
  const router = useRouter()
  const serverAction = withCallbacksServerAction(logoutServerAction, {
    onSuccess: () => {
      clearUser()
      if (onSuccess) {
        onSuccess()
      } else {
        router.replace(ROUTES.home)
      }
    },
    onError: res => {
      addToast({ color: 'danger', title: res.error })
    },
  })
  const [_, formAction, isPending] = useActionState(serverAction, null)

  return (
    <form action={formAction} className='flex w-full'>
      <input
        hidden
        name='fcmToken'
        defaultValue={storageService.getItem(STORAGE_KEYS.fcmToken) || ''}
      />
      <input hidden name='accountType' defaultValue={user?.accountType} />
      <button
        disabled={isPending}
        type='submit'
        className='w-full cursor-pointer text-start'
      >
        {label || t('actions.logout')}
      </button>
    </form>
  )
}
